export const DEFAULT_GOOGLE_ADS_SCOPES = [
  'https://www.googleapis.com/auth/adwords',
];

export const getGoogleUrl = (from: string, reqId: string, scopes: string[]) => {
  const rootUrl = 'https://accounts.google.com/o/oauth2/v2/auth';

  const options = {
    redirect_uri: import.meta.env.VITE_GOOGLE_OAUTH_REDIRECT_URI as string,
    client_id: import.meta.env.VITE_GOOGLE_OAUTH_CLIENT_ID as string,
    access_type: 'offline',
    response_type: 'code',
    prompt: 'consent',
    scope: scopes.join(' '),
    state: JSON.stringify({ from, id: reqId }),
  };

  const qs = new URLSearchParams(options);

  return `${rootUrl}?${qs.toString()}`;
};

export const DEFAULT_FACEBOOK_ADS_SCOPES = [
  'ads_read',
  'public_profile',
  'email',
  'business_management',
];

export const getFacebookUrl = (
  from: string,
  reqId: string,
  scopes: string[],
) => {
  const rootUrl = 'https://www.facebook.com/v16.0/dialog/oauth';

  const options = {
    redirect_uri: import.meta.env.VITE_FACEBOOK_OAUTH_REDIRECT_URI as string,
    client_id: import.meta.env.VITE_FACEBOOK_OAUTH_APP_ID as string,
    access_type: 'offline',
    response_type: 'code',
    // prompt: 'consent',
    scope: scopes.join(' '),
    state: JSON.stringify({ from, id: reqId }),
  };

  const qs = new URLSearchParams(options);

  return `${rootUrl}?${qs.toString()}`;
};
